import React, { useEffect, useState } from "react";
import { Button,  Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { EyeFilled } from "@ant-design/icons";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
// import useVoyageList from "../../../hooks/useVoyageList";

const ListBunkerReportCom = () => {
  const navigate = useNavigate();
  // const { voyageList } = useVoyageList();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [ship_id, set_ship_id] = useState("");
  const [ship_table_list, set_ship_table_list] = useState([]);

  const SHIP_LIST_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if (res?.status === true) {
          const ships = res?.ships || [];
          set_ship_table_list(ships);
          const firstShipId = ships[0]?.id;
          set_ship_id(firstShipId);
          if (firstShipId) {
            LIST_BUNKER_LOGBOOK_API(firstShipId);
          }
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    }
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  // useEffect(() => {
  //   if (voyageList?.length > 0) {
  //     const runningVoyage = voyageList.find((voyage) => voyage.voyage_status === true);
  //     if (runningVoyage) {
       
  //       if (runningVoyage.id) LIST_BUNKER_LOGBOOK_API(runningVoyage.id);
  //     }
  //   }
  // }, [voyageList]);

  const LIST_BUNKER_LOGBOOK_API = (ship_id) => {
    set_page_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("ship_id", ship_id);
    try {
      post(ApiURL.list_bunker_report_com, FORM_DATA).then((res) => {

        if ((res?.status == true) === true) {
          setFilteredData(res?.entries);
          set_page_loader(false);
        } else {
          set_page_loader(false);
        }
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      align: "center",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Place",
      dataIndex: "place",
      align: "center",
      key: "place",
    },
    {
      title: "Log Date",
      dataIndex: "log_date",
      align: "center",
      key: "log_date",
    },
    {
      title: "Log Time",
      dataIndex: "log_time",
      align: "center",
      key: "log_time",
    },

    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => (
        <Tooltip title="View">
          <Button
            type="primary"
            size="small"
            onClick={() => navigate(`/view-bunker-record-com/${btoa(record?.id)}`)}
            style={{ marginRight: "5px" }}
            icon={<EyeFilled />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-3">
          <label className="block-label">Select Ship</label>
          <Select
            placeholder="---- Select Ship ----"
            style={{ width: "100%" }}
            value={ship_id}
            onChange={(value) => {
              set_ship_id(value);
              LIST_BUNKER_LOGBOOK_API(value);
            }}
          >
            {ship_table_list.map((ship) =>
              !ship.soft_delete ? (
                <Select.Option key={ship.id} value={ship.id}>
                  {ship.vessel_name}
                </Select.Option>
              ) : null
            )}
          </Select>
        </div>
      </div>

      <div className="row" style={{ padding: "10px" }}>
        <div className="col-3" style={{ marginLeft: "5px", alignSelf: "end" }}>
          <div className="theme-content-title text-left">
            <h3>Bunker Record Book Information</h3>
          </div>
        </div>
        <div className="col-3"></div>
        <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="d-flex align-items-center">
            <Button
              type="primary"
              className="save_btn"
              onClick={() => navigate("/audit-trail-bunker-record")}
            >
              Audit Trail
            </Button>
          </div>
        </div>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
        rowKey="key"
        loading={page_loader}
        className="custom-table"
      />
    </>
  );
};

export default ListBunkerReportCom;
